import { useTranslation } from 'react-i18next';

import { NavItem, Section } from '../../Common/Layout';
import { RegistrationSummary } from '../helpers';
import { useNavigation } from '../../Common/useNavigation';
import { useParticipant } from '../ParticipantProvider';
import UI from '../../../common/UI';
import useLocale from '../../../common/useLocale';
import useProject from '../../useProject';

export interface PendingOrdersSectionProps {
  summary: RegistrationSummary;
  pendingOrders: RegistrationSummary['orders'];
}

const PendingOrdersSection = ({ summary, pendingOrders }: PendingOrdersSectionProps) => {
  const { t } = useTranslation();
  const { r } = useNavigation();
  const { formatCurrency, formatDate, parseDate } = useLocale();
  const { participant } = useParticipant();
  const project = useProject();

  return (
    <Section title={t('awaiting_payment')}>
      {pendingOrders.map((order) => (
        <NavItem
          to={r('Order', {
            projectId: project.id,
            participantId: participant.id,
            token: participant.access_token,
            eventId: summary.event.id,
            orderId: order.id,
          })}
          title={`${t('order')} ${order.invoice_id}`}
          key={order.id}
        >
          <UI.Div>
            <UI.H4>
              {t('order')}
              {' '}
              {order.invoice_id}
            </UI.H4>
            <UI.Div>
              <UI.Delimit>
                {formatCurrency(order.invoice_amount)}
                {formatDate(
                  parseDate(order.invoice_date, { timezone: 'UTC', format: 'internal_date' }),
                  { format: 'display_compact_date' },
                )}
              </UI.Delimit>
            </UI.Div>
            {order.remaining_amount > 0 && (
              <UI.Warning sc={{ mt: 2 }}>
                <UI.Strong>
                  {t('remaining_amount', { amount: formatCurrency(order.remaining_amount) })}
                </UI.Strong>
                {order.due_date && (
                  <>
                    {' ('}
                    {formatDate(
                      parseDate(order.due_date, {
                        timezone: 'UTC',
                        format: 'internal_date',
                      }),
                      { format: 'display_date' },
                    )}
                    )
                  </>
                )}
              </UI.Warning>
            )}
          </UI.Div>
        </NavItem>
      ))}
    </Section>
  );
};

export default PendingOrdersSection;
